import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminAllowanceList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AdminAllowanceListLayout from "../../layouts/Admin/AllowanceListLayout";

const AdminAllowanceList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AdminAllowanceListLayout />
    </>
  );
};

export default AdminAllowanceList;
